import Vue from 'vue';
import { ResizeObserver } from 'resize-observer';

const ResizeElementObserver = Vue.directive('resize', {
  inserted: (el, binding, vnode) => {
    // if ('ResizeObserver' in window) {
      let execute = null;
      const handleResize = (entries) => {
        if (!entries[0]) return;
        const entry = entries[0];
        clearTimeout(execute);
        execute = setTimeout(() => {
          const newSize = {
            height: entry.contentRect.height,
            width: entry.contentRect.width
          };
          if (binding.expression && vnode.context[binding.expression]) {
            vnode.context[binding.expression](newSize);
          }
        }, 1000);
      };
      (() => {
        const observer = new ResizeObserver(handleResize);
        observer.observe(el);
      })();
    // } else {
    //   const oldSize = {
    //     height: 0,
    //     width: 0
    //   };
    //   const emitSize = (immediately = false) => {
    //     const newSize = {
    //       height: el.clientHeight,
    //       width: el.clientWidth
    //     };
    //     if (oldSize.height !== newSize.height || oldSize.width !== newSize.width) {
    //       oldSize.width = newSize.width;
    //       oldSize.height = newSize.height;
    //       if (binding.expression && vnode.context[binding.expression]) {
    //         vnode.context[binding.expression](newSize);
    //       }
    //     }
    //     const timeOut = immediately ? 0 : 2000;
    //     setTimeout(() => {
    //       emitSize();
    //     }, timeOut);
    //   };
    //   emitSize(true);
    // }
  }
});

export default ResizeElementObserver;
